module.exports = __webpack_public_path__ + "img/89cad56.jpg";